import { withAuthenticationContext } from '@psyomics/ui-common';

import { Referrals as ReferralsFeature } from '../../../features/referrals/referrals';

const InnerReferrals = () => {
  return <ReferralsFeature isSummary={false} />;
};

const Referrals = withAuthenticationContext(InnerReferrals);

export { Referrals };
